export default {
  cad: {
    sectionTitle: 'CAD',
    previewMode: 'プレビューモード',
    surface: 'サーフェス',
    wireframe: 'ワイヤーフレーム',
    wireframeUnavailable: 'ワイヤーフレームプレビューはまだ利用できません',
  },
  visualization: {
    sectionTitle: '可視化',
    qualityMetric: '品質メトリック',
  },
  qualityMetric: {
    // メッシュビューアの品質指標ドロップダウン. [日本語 + 英語原名]
    // を同じ行に併記する MeshGen サイズプリセットと同じパターン.
    // SICN / Gamma は英字略語のまま.
    sicn: 'SICN 形状スコア (Ideal=1)',
    gamma: 'Gamma 形状スコア (Ideal=1)',
    skewness: '歪度 Skewness',
    aspectRatio: 'アスペクト比 Aspect ratio',
    minAngle: '最小角 Minimum angle',
    nonOrthogonality: '非直交性 Non-orthogonality',
  },
  cellInfo: {
    // クリックしたセルの詳細読み出し. 要素タイプ名は品質指標と同じ
    // [日本語 + 英語原名] パターン.
    element: '要素 #{{id}}',
    region: 'リージョン {{tag}}',
    type: {
      triangle: '三角形 Triangle',
      quadrangle: '四角形 Quadrangle',
      tetrahedron: '四面体 Tetrahedron',
      hexahedron: '六面体 Hexahedron',
      prism: 'プリズム Prism',
      pyramid: 'ピラミッド Pyramid',
      polyhedron: '多面体 Polyhedron',
    },
  },
  meshViewer: {
    view: '表示',
    auto: '自動',
    autoWithSource: '自動（{{source}}）',
    diagnosisStl: 'Diagnosis STL',
    serverStl: 'サーバー STL',
    fluidDomain: '流体領域',
    fineStl: '高精細 STL',
    cadTessellation: 'CAD テッセレーション',
    extractedCavity: '抽出された空洞',
    loadingExtractedCavity: '抽出された空洞を読み込み中…',
    faceLabel: '面 {{index}}',
    clickFaceToAddBl: '面をクリックして BL に追加',
    pickSurface: '選択対象: {{source}}',
    noFluidDomainFallback: '流体空洞ではなく、ボディ表面で選択しています。',
    rendererError: 'レンダラーエラー',
    webgpuUnsupported:
      'このブラウザは WebGPU に対応していません。最新版の Chrome または Edge をお試しください。',
    webgpuUnavailableTitle: '3D ビューアには WebGPU が必要です',
    webgpuUnavailableBody:
      'ブラウザが GPU セッションを開始できなかったため、3D ビューアを描画できません。これはブラウザまたは GPU の設定の問題で、メッシュ自体に問題はありません。',
    webgpuStepGpuPage:
      'edge://gpu または chrome://gpu を開き、WebGPU が「Hardware accelerated」になっているか確認してください。',
    webgpuStepAccel:
      'ブラウザ設定で「使用可能な場合はグラフィック アクセラレータを使用する」をオンにし、ブラウザを再起動してください。',
    webgpuStepDriver: 'グラフィックドライバーを更新してください。',
    webgpuStepRemote:
      'リモートデスクトップや仮想マシンを使用していませんか？ GPU が無い場合が多いため、ローカルで実行してください。',
    webglUnavailableTitle: '3D 表示には WebGL が必要です',
    webglUnavailableBody:
      'ブラウザが WebGL を開始できなかったため、この 3D 表示を描画できません。これはブラウザまたは GPU の設定の問題で、結果自体に問題はありません。',
    webglStepGpuPage:
      'edge://gpu または chrome://gpu を開き、WebGL が「Hardware accelerated」になっているか確認してください。',
    meshTooLargeTitle: 'メッシュが大きすぎて表示できません',
    meshTooLargeBody:
      'このメッシュはセル数が多すぎて、ブラウザーの 3D ビューアーでは読み込めません。メッシュの生成は成功しています。外部ツールで開くには、ダウンロード（OpenFOAM、Fluent、STL）してください。',
    meshUnreadableTitle: 'このメッシュを読み取れません',
    meshUnreadableBody:
      'メッシュの生成は成功しましたが、ビューアーが読み取れませんでした。これはビューアーの不具合であり、メッシュの問題ではありません。ダウンロードして別のツールで開き、下記のエラー行を報告してください。',
    uploadPrompt: 'CAD モデルをアップロードして開始します',
    loadingMesh: 'メッシュを読み込み中',
    loadingDiagnosisPreview: 'Diagnosis プレビューを読み込み中',
    loadingPreview: 'プレビューを読み込み中',
    buildingCadPreview: 'CAD プレビューを作成中',
    previewUnavailableTitle: '3D プレビューを利用できません',
    previewUnavailableHint:
      'メッシュの生成は可能です。影響を受けるのはプレビューのみです。',
    noDiagnosisStl:
      'このジオメトリには Diagnosis STL がありません。下から別の表示を選択してください。',
    noServerPreview:
      'このジオメトリにはサーバープレビューがありません。下から別の表示を選択してください。',
    noPreviewAvailable: 'このファイルには利用可能なプレビューがありません。',
    previewProvenanceSimplify:
      'このバージョンはアップロードされたファイルではなく簡略化の候補です。承認するまで 3D プレビューはありません。',
    buildPreviewMeshing: 'メッシュ生成中… · {{stage}}',
    buildPreviewStageBlockmesh: 'ドメイングリッド',
    buildPreviewStageSnapped: '表面（境界層の前）',
    buildPreviewBuilding: '生成中',
    buildPreviewTooltip:
      'メッシュ生成中のライブプレビューです（最終結果ではありません）。「ドメイングリッド」はメッシュ領域を覆う背景ブロック、「表面」は境界層の直前に取得したジオメトリ表面です。',
  },
  viewerOverlay: {
    bodySolid: 'ソリッド',
    bodyXray: '透視',
    bodyHidden: '非表示',
    viewAlong: '{{axis}}軸方向から見る',
    toggleWireframe: 'ワイヤーフレーム切替',
    modelSolid: 'モデル: ソリッド',
    modelXray: 'モデル: X線',
    modelHidden: 'モデル: 非表示',
    toggleClip: 'クリップ切替',
    flipSide: '面を反転',
    flipNeedsClip: 'クリップを有効にすると反転できます',
    sliceViewPlane: 'ビュー平面でスライス',
    slicePosition: 'スライス位置',
    fitView: 'ビューに合わせる',
    clipCrinkleActive:
      'クリンクル切断：セルを丸ごと保持します。クリーンな断面平面に切り替えます。',
    clipSectionActive:
      '断面切断：クリーンな平面。セルを丸ごと保持するクリンクル切断に戻します。',
    crinkleCut: 'クリンクル',
    sectionCut: '断面',
  },
  controlsHelp: {
    show: 'ビューア操作',
    mouse: 'マウス',
    keyboard: 'キーボード',
    dragL: '左ドラッグ',
    dragR: '右ドラッグ',
    shiftDragL: 'Shift + 左ドラッグ',
    dragLR: '左 + 右ドラッグ',
    wheel: 'ホイール',
    click: 'クリック',
    orbit: '回転',
    pan: 'パン',
    roll: 'ロール',
    zoom: 'カーソル方向へズーム',
    pick: 'セルを検査',
    lookAxis: 'X / Y / Z 軸方向から見る',
    pitch: 'ピッチ ±90°',
    yaw: 'ヨー ±90°',
    rollKey: 'ロール ±90°',
    slice: 'ビュー平面でスライス',
    cycleBody: 'ソリッド / 透視 / 非表示 を循環',
    wireframe: 'ワイヤーフレーム切替',
    clip: '断面切断のオン/オフ',
    flip: '断面の面を反転',
  },
  viewerLoading: {
    loadingMesh: 'メッシュを読み込み中...',
    loadingPreview: 'プレビューを読み込み中...',
    parsingMesh: 'メッシュを解析中...',
    downloadingMesh: 'メッシュをダウンロード中',
    cachingMesh: 'メッシュをキャッシュ中...',
    restoringMemory: 'メモリを復元中...',
    loadingCached:
      'キャッシュされたメッシュを読み込み中 {{received}} / {{total}} バイト',
    downloading: 'ダウンロード中 {{received}} / {{total}} バイト',
  },
  debugViewer: {
    loadModel: 'モデルを読み込む',
    loading: '読み込み中…',
    meshFileLabel: 'メッシュファイル',
    qualityFileLabel: '品質メトリクスファイル',
  },
  // 公開ページ `/whats-new` の枠組み文言 — ページ見出し、セクション
  // ラベル、状態バッジ. リリースノート本文は英語のまま (毎リリース
  // 3 言語再翻訳を避けるため、whats-new/AGENTS.md 参照).
  changelog: {
    backToApp: 'アプリに戻る',
    title: '更新履歴とロードマップ',
    subtitle: 'Khorium MeshGen のリリースノートと今後の予定',
    roadmapHeader: 'ロードマップ',
    releasedHeader: 'リリース済み',
    badgeLatest: '最新',
    badgeUpcoming: '近日公開',
    sectionLabelNew: '新機能',
    sectionLabelImproved: '改善',
    sectionLabelFixed: '修正',
    datePlanned: '予定',
  },
} as const;
